import { GraduationCap, BookOpen, CreditCard } from "lucide-react";

import DataFetcherTemplateHome from "../../hooks/DataFetcherTemplateHome";
import BlockImageCabecera from "../../components/BlockImageCabecera";
import Block3Columns from "../../components/Block3Columns";
import ConectUs from "../../components/ConectUs";
import OfferPosgrados from "../../components/view/OfferPosgrados";
import { motion } from "framer-motion";
import PosgradoPagos from "../../components/PosgradoPagos";
import Modal from "../../components/Modal";
import ImageGallery from "../../components/ImageGallery";

const url =
  "https://be-ofertas.utpl.edu.ec/jsonapi/node/template_home/51ae7ef1-57ff-440d-a341-a7a7bd441116" +
  "?include=field_imagen_portada.field_media_image,field_gallery.field_media_image" +
  "&fields[node--template_home]=title,field_gallery,field_imagen_portada,field_texto_portada,field_bloque1,field_bloque2,field_bloque3,field_bloque4" +
  "&fields[media--image]=field_media_image" +
  "&fields[file--file]=uri";

function Posgrados() {
  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
        when: "beforeChildren",
        staggerChildren: 0.2,
      },
    },
  };

  const DataDisplay = ({ data }) => (
    <div>
      <div className="mt-[65px]">
        <img src={data.imagen_portada} alt="cabecera" />{" "}
      </div>
    <section className="max-w-5xl mx-auto my-10 px-4 sm:px-6 lg:px-0">
  <div className="flex flex-col lg:flex-row items-center gap-8 bg-gradient-to-br from-[#004270] via-[#002f52] to-slate-950 rounded-2xl shadow-xl border border-[#febe10]/20 ">
    <motion.div
      className="w-full lg:w-3/5"
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
    >
      <div
        dangerouslySetInnerHTML={{ __html: data.bloque1 }}
        className="p-8
        /* Badge */
        [&_h4]:inline-flex
        [&_h4]:items-center
        [&_h4]:justify-center
        [&_h4]:text-xs
        [&_h4]:uppercase
        [&_h4]:text-[#febe10]
        [&_h4]:bg-[#febe10]/10
        [&_h4]:px-3
        [&_h4]:py-1.5
        [&_h4]:rounded-full
        [&_h4]:border
        [&_h4]:border-[#febe10]/30
        [&_h4]:w-full
        [&_h4]:sm:w-fit
        [&_h4]:max-w-full
        [&_h4]:text-center
        [&_h4]:mb-4

        /* Título */
        [&_h2]:text-2xl
        [&_h2]:md:text-3xl
        [&_h2]:font-bold
        [&_h2]:text-white
        [&_h2]:leading-tight
        [&_h2]:max-w-3xl
        [&_h2_strong]:text-[#febe10]

        /* Botón */
        [&_a]:inline-flex
        [&_a]:items-center
        [&_a]:justify-center
        [&_a]:px-6
        [&_a]:py-3
        [&_a]:mt-6
        [&_a]:text-sm
        [&_a]:font-bold
        [&_a]:text-slate-900
        [&_a]:bg-[#febe10]
        [&_a]:hover:bg-[#e0a60b]
        [&_a]:rounded-xl
        [&_a]:shadow-lg
        [&_a]:transition-all
        [&_a]:duration-200
        [&_a]:hover:scale-[1.02]
        "
      />

      <div className="p-6 [&_span]:text-white [&_span]:font-bold [&_span:hover]:text-[#febe10] mt-6">
        <Modal
          title="⏯️ Proceso de postulación y matrícula en el sistema académico"
          content={
            <div
              className="[&_iframe]:mx-auto [&_iframe]:w-full [&_iframe]:max-w-full"
              dangerouslySetInnerHTML={{
                __html: data.bloque4,
              }}
            />
          }
        >
          {" "}
        </Modal>
      </div>
    </motion.div>

    <div className="w-full lg:w-2/5">
      <ImageGallery gallery={data.galeria} />
    </div>
  </div>
</section>
    </div>
  );

  return (
    <>
      <DataFetcherTemplateHome url={url}>
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplateHome>

      <div className="pb-16 pt-4">
        <OfferPosgrados></OfferPosgrados>
      </div>

      <div className="px-6">
        <PosgradoPagos></PosgradoPagos>
      </div>
      <div className="padding2">
        <ConectUs
          lema="Descubre contenido exclusivo, mantente al tanto de las últimas novedades y únete a nuestra comunidad de estudiantes de posgrado."
          instagram="https://www.instagram.com/utplposgrados/"
          facebook="https://www.facebook.com/utplposgrados"
        ></ConectUs>
      </div>
    </>
  );
}

export default Posgrados;
